import { render } from "./AvailabilityCalendar.vue?vue&type=template&id=5fff57c7&scoped=true"
import script from "./AvailabilityCalendar.vue?vue&type=script&lang=js"
export * from "./AvailabilityCalendar.vue?vue&type=script&lang=js"

import "./AvailabilityCalendar.vue?vue&type=style&index=0&id=5fff57c7&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fff57c7"]])

export default __exports__